export default __webpack_public_path__ + "static/media/cif-vn.80bbd04e.svg";